
import {finalize} from 'rxjs/operators';
import { each } from 'lodash';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Dossier } from './dossier';
import { DossierModel } from '../dossier-model/dossier-model';
import { RecordLink } from '../record-link/record-link';
import { Record } from '../record/record';
import { RecordSearchDialogComponent } from '../record/record-search-dialog.component';
import { RecordService } from '../record/record.service';
import { NotifierService, DialogService } from '../ui';
import { Link } from './link';
import { TreeItem, DossierTree, TreeItemWithRecord, GroupItem, DataItem } from './tree';
import { LinkGroup } from '../link-group/link-group';
import { DataLink } from '../data-link/data-link';

@Component({
  templateUrl: './archived-dossier-details.component.html',
})
export class ArchivedDossierDetailsComponent implements OnInit {
  
  dossier: Dossier
  dossierModel: DossierModel
  dossierTree: DossierTree

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private recordService: RecordService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {

    // Get the data
    this.notifier.startProgress();

    this.route.data.subscribe((data) => {

      this.dossierModel = data.dossierModel;

      let dossier: Dossier = data.dossier;

      // Attach models on each link
      this.attachModelToLinks(dossier.links);

      // Set the dossier
      this.dossier = dossier;
      this.dossierTree = new DossierTree(this.dossier, this.dossierModel);

      // Select the root link
      this.loadRecordLink(this.dossierTree.rootItem);
    });
  }

  private attachModelToLinks(links: Link[]) {
    each(links, link => {
      this.attachModelToLink(link);
    });
  }
  
  private attachModelToLink(link: Link) {
    link.model = this.dossierModel.data[link.name];
  }

  get selectedRecordLink(): RecordLink {
    let item = this.dossierTree.selectedItem as any;
    if (item && (item.type === 'ROOT' || item.type === 'RECORD')) {
      let recordItem = item as TreeItemWithRecord;
      
      if(recordItem.link && recordItem.link.record) {
        return recordItem.link;
      }
    }

    return null;
  }

  get selectedDataLink(): DataLink {
    let item = this.dossierTree.selectedItem;
    if (item && (item.type === 'DATA')) {
      let dataItem = item as DataItem;

      if (dataItem.link && dataItem.link) {
        return dataItem.link;
      }
    }

    return null;
  }

  get selectedLinkGroup(): LinkGroup {
    let item = this.dossierTree.selectedItem;
    if (item && (item.type === 'GROUP')) {
      let groupItem = item as GroupItem;

      if (groupItem.group && groupItem.group) {
        return groupItem.group;
      }
    }

    return null;
  }

  cleanupNewItem() {
    let item = this.dossierTree.selectedItem;

    if(item && item.isNew) {

      if(item.parent) {
        item.parent.removeChild(item);
      }
    }
  }

  selectItem(item: TreeItem) {

    if(!item) {
      return;
    }

    if(item === this.dossierTree.selectedItem) {
      return;
    }
    
    if (!item.canSelect) {
      return;
    }

    this.cleanupNewItem();

    this.dossierTree.selectedItem = item;
    
    if (item.type === 'ROOT' || item.type === 'RECORD') {
      this.loadRecordLink(item as any);
    }
  }

  selectRootItem() {
    this.selectItem(this.dossierTree.rootItem);
  }

  loadRecordLink(item: TreeItemWithRecord) {
    
    if (this.notifier.currentProgress === 0) {
      this.notifier.startProgress();
    }
    else {
      this.notifier.updateProgress(50);
    }

    this.recordService
      .recordFromLink(this.dossier.id, item.link.id).pipe(
      finalize(() => {
        this.notifier.endProgress();
      }))
      .subscribe((link) => {
        this.attachModelToLink(link);
        item.link.replaceWith(link);
      });
  }

  lookupRecord(event: Event) {
    this.dialogService.show({
      component: RecordSearchDialogComponent,
      props: {

        hideId: this.dossierTree.rootItem.link.record.id,

        onClose: () => {
          this.dialogService.hide();
        },

        onSelect: (record: Record) => {
          this.dialogService.hide();

          this.recordService
            .record(record.id).pipe(
            finalize(() => {
              this.notifier.endProgress();
            }))
            .subscribe((record) => {
              this.selectedRecordLink.record = record;
            });
        }
      }
    });

    event.preventDefault();
  }
}
